import type { IconData } from '@stacksjs/iconify-core'

export const handZoom: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M29.71 13.72h1.53v6.09h-1.53Zm-1.52 6.09h1.52v4.58h-1.52Zm0-7.62h1.52v1.53h-1.52Zm-1.52 15.24H12.95v-3.04h-1.52v3.04H9.9V32h19.81v-4.57h-1.52v-3.04h-1.52Zm0 3.05h-3.05v-1.52h3.05Zm0-19.81h1.52v1.52h-1.52Zm-1.53 3.05h1.53v3.05h-1.53Zm-4.57 0h1.53v3.05h-1.53Zm-4.57 0h1.52v3.05H16Zm0-3.05h10.67V9.15h-9.15V1.53H16zM12.95 0H16v1.53h-3.05ZM9.9 21.34h1.53v3.05H9.9Zm1.53-6.1v3.05h1.52V1.53h-1.52v12.19H9.9v1.52zm-3.05 4.57H9.9v1.53H8.38Zm0-7.62H9.9v1.53H8.38Zm0-7.61H9.9V0H5.33v1.53h1.53v1.52h1.52zM6.86 18.29h1.52v1.52H6.86Zm-1.53-7.62h3.05v1.52H5.33Zm0 6.1h1.53v1.52H5.33Z\"/><path fill=\"currentColor\" d=\"M5.33 3.05h1.53v1.53H5.33Zm-1.52 9.14h1.52v4.58H3.81Zm1.52-4.57H3.81V6.1H2.29V4.58H.76v4.57h4.57zM3.81 4.58h1.52V6.1H3.81Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default handZoom
